import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AuditLogViewModel } from "../features/audit-log/audit-log-viewmodel";
import { OperationsViewModel } from "../features/operations/operations-viewmodel";
import { RegistrationsViewModel } from "../features/registrations/registrations-viewmodel";
import { UserIdViewModel } from "../features/user-id/user-id-viewmodel";
import { AppRoutes } from "../routes/routes";
import { useViewModel } from "../viewmodel/use-view-model";
export const UserTabs = ({ selected }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const regVM = useViewModel(RegistrationsViewModel);
    const opVM = useViewModel(OperationsViewModel);
    const auditVM = useViewModel(AuditLogViewModel);
    const userVM = useViewModel(UserIdViewModel);
    const handleReload = async () => {
        if (selected === AppRoutes.Registrations) {
            await regVM.getRegistrations(userVM.userId, true);
        }
        else if (selected === AppRoutes.Operations) {
            await opVM.getOperations(userVM.userId, opVM.registrationIdFilter, true);
        }
        else if (selected === AppRoutes.AuditLog) {
            await auditVM.getAuditLog(userVM.userId, true);
        }
    };
    const tabs = [
        {
            label: t("user.tabs.registrations"),
            route: AppRoutes.Registrations,
        },
        {
            label: t("user.tabs.operations"),
            route: AppRoutes.Operations,
            params: { filterRegId: "" }
        },
        {
            label: t("user.tabs.auditLog"),
            route: AppRoutes.AuditLog,
        },
    ];
    return (_jsxs("div", { className: "d-flex align-items-center", children: [_jsx("ul", { className: "nav nav-tabs card-header-tabs", children: tabs.map(({ route, label, params }) => {
                    const isActive = selected === route;
                    return (_jsx("li", { className: "nav-item cursor-pointer", children: _jsx("button", { className: `nav-link ${isActive ? "active fw-bold" : ""}`, type: "button", role: "tab", "aria-controls": label, "aria-selected": isActive ? "true" : "false", onClick: () => navigate(route, params), children: t(label) }) }, route));
                }) }), _jsxs("button", { className: "btn btn-outline-secondary btn-sm ms-auto", onClick: () => handleReload(), children: [_jsx("i", { className: "bi bi-arrow-clockwise me-1" }), t("userTabs.reload")] })] }));
};
